let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4pHmN")).then(() => parcelRequire('jPzEK'));